import {Accordion, AccordionItem, Button, Col, Collapse, Row} from "reactstrap";
import classnames from "classnames";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import RequestReimbursementExpense from "../Models/Request/RequestReimbursementExpense";
import React, {useEffect, useRef, useState} from "react";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import _ from 'lodash';
import {useTranslation} from "react-i18next";
import {InputMessage} from "../../AppSystem/Helpers/InputMessage";
import {InfoPageMessage} from "../../Common/Components/Button/InfoPageMessage";

export function ReimbursementExpense({ data, onChange, onValidate, onCancel, editMode = false, accountingJson, extraField, setIsDeletedFile, setIsDeletedExtraFile, extraField2, attributeValue = null, setLocalDisplay, localDisplay}) {
    const { t } = useTranslation()
    // CANCEL STATE
    const [cancelModel, setCancelModel] = useState(data);

    // STATES
    const [accordionStatus, setAccordionStatus] = useState('1');
    const [flagDate, setFlagDate] = useState(true);
    const [wrongFileFormat, setWrongFileFormat] = useState(false);
    //const [localDisplay, setLocalDisplay] = useState(false);

    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        if (data?.additionalInfo?.program && data?.additionalInfo?.program !== "") {
            setSelectedOption("option1");
        } else if (data?.additionalInfo?.participantsFileId && data?.additionalInfo?.participantsFileId !== "") {
            setSelectedOption("option2");
        } else if (data?.additionalInfo?.program === "" && data?.additionalInfo?.participantsFileId === "") {
            setSelectedOption(null);
        }
    }, [data?.additionalInfo?.program, data?.additionalInfo?.participantsFileId]);

    // REF
    const formDivRefExpense = useRef(null);

    // CANCEL MODEL
    useEffect(() => {
        if (editMode === true) {
            const copyModel = _.cloneDeep(data);
            setCancelModel(copyModel);
            setLocalDisplay(true);
        }
    }, [editMode]);

    const messageAccounting = InputMessage(accountingJson.accounting, data?.accountingId);

    // EXTRA FIELDS
    let program = "";
    let participantsFile = "";
    let programFile = "";
    let participants = "";
    let isParticipants = false;

    if (data?.accountingName === "Representation, avdragsgill (måltid max 60 kr)" || data?.accountingName === "Representation, ej avdragsgill (måltid över 60 kr)" || data?.accountingName === "Övriga möten fika under 60 kr/person (6071)" || data?.accountingName === "Mat och fika över 60 kr/person samt avtackningsgåvor (6072)") {
        isParticipants = true;

        const handleOptionChange = (e) => {
            setSelectedOption(e.target.value);
            onChange(e, "radio");
        };

        participants = <Col lg={12}>
            <div id="divRadioInputs" className="position-relative"
                 style={{padding: "15px 0", display: "flex", flexDirection: "row", gap: "15px", alignItems: "center"}}>
                <label style={{display: "flex", alignItems: "center", gap: "3px"}}>
                    <input type="radio" name="options" value="option1" onChange={handleOptionChange}
                           checked={selectedOption === "option1"}/>
                    <span>Ange deltagare manuellt</span>
                </label>
                <label style={{display: "flex", alignItems: "center", gap: "3px"}}>
                    <input type="radio" name="options" value="option2" onChange={handleOptionChange}
                           checked={selectedOption === "option2"}/>
                    <span>Bifoga deltagarlista som fil</span>
                </label>
                <div id="errorRadio" className="error tooltip-custom show-custom d-none"
                     style={{color: '#f56e6e'}}>
                    {t('formPlaceholder.selectOption')}
                </div>
            </div>
        </Col>;

        if (data?.additionalInfo && Object.keys(data?.additionalInfo).length > 0) {
            if (data?.additionalInfo.program !== undefined && selectedOption === "option1") {
                program = <Col lg={12}>
                    <div className="position-relative">
                        <CustomInput model={RequestReimbursementExpense} attribute="program"
                                     customField={extraField !== null && extraField.requestName === "Program" ? extraField : (extraField2 !== null && extraField2.requestName === "Program" ? extraField2 : null)}
                                     data={data?.additionalInfo.program}
                                     customChange={(e) => {
                                         onChange(e, "dynamic")
                                     }}
                        />
                        <div id="errorProgram" className="error tooltip-custom-normal show-custom d-none"
                             style={{color: '#f56e6e'}}>
                            {t('validationMessage.fieldRequired')}
                        </div>
                        <div className="text-green d-flex align-items-center mb-3">
                            <i className='bx bx-info-circle fs-5 pe-2'/>Skriv deltagarna i rutan eller kopiera in en deltagarlista från ett dokument <br/>(Använd "," eller en ny rad för att separera deltagare)
                        </div>
                    </div>
                </Col>;
            }

            if (data?.additionalInfo.participantsFileId !== undefined && selectedOption === "option2") {
                participantsFile = <Col lg={12}>
                    <div className="position-relative">
                        <CustomInput model={RequestReimbursementExpense} attribute="participantsFileId"
                                     data={data?.additionalInfo.participantsFileId} customChange={(e) => {
                            onChange(e, "dynamic", "participantsFileId")
                        }}
                                     fileId={data?.additionalInfo.participantsFileId !== "" ? data?.additionalInfo.participantsFileId : null}
                                     fileExtension={data?.additionalInfo.participantsFileId !== "" ? data?.additionalFileExtension : null}
                                     fileName={data?.additionalFileName && data?.additionalFileName !== "" ? data?.additionalFileName : (data?.additionalFileExtension && data?.additionalFileExtension !== "" ? data?.additionalFileExtension : null)}
                                     wrongFileFormat={wrongFileFormat}
                                     customField={extraField !== null && extraField.requestName === "ParticipantsFileId" ? extraField : (extraField2 !== null && extraField2.requestName === "ParticipantsFileId" ? extraField2 : null)}
                                     setIsDeleted={setIsDeletedExtraFile}
                        />
                        <div id="errorParticipantsFileId" className="error tooltip-custom-normal show-custom d-none"
                             style={{color: '#f56e6e'}}>
                            {t('validationMessage.fieldRequired')}
                        </div>
                    </div>
                </Col>;
            }
        }
    } else {
        if (data?.additionalInfo && Object.keys(data?.additionalInfo).length > 0) {
            if (data?.additionalInfo.program !== undefined) {
                program = <Col lg={12}>
                    <div className="position-relative">
                        <CustomInput model={RequestReimbursementExpense} attribute="program"
                                     customField={extraField !== null && extraField.requestName === "Program" ? extraField : (extraField2 !== null && extraField2.requestName === "Program" ? extraField2 : null)}
                                     data={data?.additionalInfo.program}
                                     customChange={(e) => {
                                         onChange(e, "dynamic")
                                     }}
                        />
                        <div id="errorProgram" className="error tooltip-custom-normal show-custom d-none"
                             style={{color: '#f56e6e'}}>
                            {t('validationMessage.fieldRequired')}
                        </div>
                    </div>
                </Col>;
            }

            if (data?.additionalInfo.participantsFileId !== undefined) {
                participantsFile = <Col lg={12}>
                    <div className="position-relative">
                        <CustomInput model={RequestReimbursementExpense} attribute="participantsFileId"
                                     data={data?.additionalInfo.participantsFileId} customChange={(e) => {
                            onChange(e, "dynamic", "participantsFileId")
                        }}
                                     fileId={data?.additionalInfo.participantsFileId !== "" ? data?.additionalInfo.participantsFileId : null}
                                     fileExtension={data?.additionalInfo.participantsFileId !== "" ? data?.additionalFileExtension : null}
                                     fileName={data?.additionalFileName && data?.additionalFileName !== "" ? data?.additionalFileName : (data?.additionalFileExtension && data?.additionalFileExtension !== "" ? data?.additionalFileExtension : null)}
                                     wrongFileFormat={wrongFileFormat}
                                     customField={extraField !== null && extraField.requestName === "ParticipantsFileId" ? extraField : (extraField2 !== null && extraField2.requestName === "ParticipantsFileId" ? extraField2 : null)}
                                     setIsDeleted={setIsDeletedExtraFile}
                        />
                        <div id="errorParticipantsFileId" className="error tooltip-custom-normal show-custom d-none"
                             style={{color: '#f56e6e'}}>
                            {t('validationMessage.fieldRequired')}
                        </div>
                    </div>
                </Col>;
            }
            if (data?.additionalInfo.programFileId !== undefined) {
                programFile = <Col lg={12}>
                    <div className="position-relative">
                        <CustomInput model={RequestReimbursementExpense} attribute="programFileId"
                                     data={data?.additionalInfo.programFileId} customChange={(e) => {
                            onChange(e, "dynamic", "programFileId")
                        }}
                                     fileId={data?.additionalInfo.programFileId !== "" ? data?.additionalInfo.programFileId : null}
                                     fileExtension={data?.additionalInfo.programFileId !== "" ? data?.additionalFileExtension : null}
                                     fileName={data?.additionalFileName && data?.additionalFileName !== "" ? data?.additionalFileName : (data?.additionalFileExtension && data?.additionalFileExtension !== "" ? data?.additionalFileExtension : null)}
                                     wrongFileFormat={wrongFileFormat}
                                     customField={extraField !== null && extraField.requestName === "ProgramFileId" ? extraField : (extraField2 !== null && extraField2.requestName === "ProgramFileId" ? extraField2 : null)}
                                     setIsDeleted={setIsDeletedExtraFile}
                        />
                        <div id="errorProgramFileId" className="error tooltip-custom-normal show-custom d-none"
                             style={{color: '#f56e6e'}}>
                            {t('validationMessage.fieldRequired')}
                        </div>
                    </div>
                </Col>;
            }
        }
    }

    return (
        <>
            <Accordion id="accordionBordered" className="" open={accordionStatus}>
                <AccordionItem
                    className={`accordion-grey bg-green mb-4 rounded ${localDisplay === false ? 'border-0' : 'border-2 border-green'}`}>
                    <h2 className="accordion-header" id="accordionborderedExample3">
                        <button className={classnames(`py-2 pe-1 w-100 accordion-button d-flex justify-content-between ${localDisplay === false ? 'accordion-grey text-green' : 'bg-green text-white'} fw-bold border-bottom-0`, { collapsed: !localDisplay })} type="button" style={{ cursor: "pointer" }}
                        onKeyDown={() => {setLocalDisplay(true)}} onClick={() => {setLocalDisplay(!localDisplay)}}>
                            <div>
                                {t('reimbursement.expense')}
                            </div>
                            {localDisplay === false ? <i className="bx bx-chevron-down fs-3"></i> : <i className="bx bx-chevron-up text-white fs-3"></i>}
                        </button>
                    </h2>
                    <Collapse isOpen={localDisplay} className="accordion-collapse" id="accor_borderedExamplecollapse3" >
                        <div className="accordion-body" ref={formDivRefExpense}>
                            <Row>
                                <Col lg={6} className="pt-3">
                                    <CustomInput model={RequestReimbursementExpense} attribute='dateReceive' data={data?.dateReceive} customChange={(e) => {
                                        onChange(e, "dateReceive");
                                    }}/>

                                </Col>
                                <Col lg={6} className="pt-3">
                                    <CustomInput model={RequestReimbursementExpense} attribute='accountingId' data={data?.accountingId}
                                                 customChange={(e) => {
                                                     onChange(e, "accountingId");
                                                 }}
                                                 customOptions={Object.keys(accountingJson).length > 0 ? accountingJson : null}/>
                                    {messageAccounting}
                                </Col>
                                <Col lg={data?.vatAmount === null ? 12 : 6} className="pt-3">
                                    <CustomInput model={RequestReimbursementExpense} attribute='amount' data={data?.amount !== 0 ? data?.amount : ""} customChange={(e) => onChange(e, "amount")}/>
                                </Col>
                                {data?.vatAmount !== null ?
                                    <Col lg={6} className="pt-3 position-relative">
                                        <CustomInput
                                            model={RequestReimbursementExpense}
                                            attribute='vatAmount'
                                            data={data?.vatAmount !== null && data?.vatAmount !== undefined ? data?.vatAmount.toString() : ""}
                                            customChange={(e) => onChange(e, "vatAmount")}
                                        />
                                        <div className={`error tooltip-custom-up-field ${data?.amount !== 0 && data?.vatAmount !== 0 && data?.amount <= data?.vatAmount ? 'opacity-1' : 'opacity-0'}`} style={{color: '#f56e6e'}}>
                                            {t('validationMessage.vatLessAmount')}
                                        </div>
                                    </Col>
                                    : ''}
                                <Col lg={12} className="pt-3">
                                    <CustomInput model={RequestReimbursementExpense} attribute='fileId' data={''}
                                                 customChange={(e) => {
                                                     onChange(e, "fileId")
                                                 }}
                                                 fileId={data?.fileId !== "" ? data?.fileId : null}
                                                 fileExtension={data?.fileExtension && data?.fileExtension !== "" ? data?.fileExtension : null} fileName={data?.fileName && data?.fileName !== "" ? data?.fileName : (data?.fileExtension && data?.fileExtension !== "" ? data?.fileExtension : null)} wrongFileFormat={wrongFileFormat}
                                                 setIsDeleted={setIsDeletedFile}
                                                 validateAttribute={attributeValue}
                                    />
                                </Col>
                                {isParticipants === false ? (
                                    <>
                                        {program}
                                        {participantsFile}
                                        {programFile}
                                    </>
                                ) : (
                                    <div>
                                        {participants}
                                        {selectedOption === "option1" && program}
                                        {selectedOption === "option2" && participantsFile}
                                    </div>
                                )}

                                {editMode === true ?
                                    <Col lg={12} className="text-center text-danger">
                                        {t('validationMessage.fileDeletedImportant')}
                                    </Col>
                                    : ""}
                                <Col lg={12} className="text-end pt-3">
                                    {editMode === true ? <Button className="bg-secondary me-3" onClick={() => onCancel(cancelModel)}>{t('button.cancel')}</Button> : ""}
                                    <CustomSubmitButton text={editMode === true ? t('button.save') : t('reimbursement.addExpense')} customClick={onValidate} typeFile={true} formDivRef={formDivRefExpense}/>
                                </Col>
                            </Row>
                        </div>
                    </Collapse>
                </AccordionItem>
            </Accordion>
        </>
    );
}